/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Transcript_TitleInputs */

const en_delete_transcript_title = /** @type {(inputs: Delete_Transcript_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Transcript`)
};

const fr_delete_transcript_title = /** @type {(inputs: Delete_Transcript_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer la transcription`)
};

const de_delete_transcript_title = /** @type {(inputs: Delete_Transcript_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protokoll löschen`)
};

const it_delete_transcript_title = /** @type {(inputs: Delete_Transcript_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina trascrizione`)
};

const ru_delete_transcript_title = /** @type {(inputs: Delete_Transcript_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить расшифровку`)
};

const es_delete_transcript_title = /** @type {(inputs: Delete_Transcript_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar transcripción`)
};

const zh_cn2_delete_transcript_title = /** @type {(inputs: Delete_Transcript_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除成绩单`)
};

const ja_delete_transcript_title = /** @type {(inputs: Delete_Transcript_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トランスクリプトを削除`)
};

const hi_delete_transcript_title = /** @type {(inputs: Delete_Transcript_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिलेख हटाएं`)
};

const pt_pt2_delete_transcript_title = /** @type {(inputs: Delete_Transcript_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir transcrição`)
};

/**
* | output |
* | --- |
* | "Delete Transcript" |
*
* @param {Delete_Transcript_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const delete_transcript_title = /** @type {((inputs?: Delete_Transcript_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Transcript_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_delete_transcript_title(inputs)
	if (locale === "de") return de_delete_transcript_title(inputs)
	if (locale === "it") return it_delete_transcript_title(inputs)
	if (locale === "ru") return ru_delete_transcript_title(inputs)
	if (locale === "es") return es_delete_transcript_title(inputs)
	if (locale === "zh-CN") return zh_cn2_delete_transcript_title(inputs)
	if (locale === "ja") return ja_delete_transcript_title(inputs)
	if (locale === "hi") return hi_delete_transcript_title(inputs)
	if (locale === "pt-PT") return pt_pt2_delete_transcript_title(inputs)
	return en_delete_transcript_title(inputs)
});